import React from "react";
import { useSelector } from "react-redux";
import classes from './StudentsList.module.css';
import ScrollLTR from "../../../../lms-shared/UI/ScrollLTR";
import DragAndDropStudentList from "../shared/DragAndDropStudentList/DragAndDropStudentList";

const StudentsList = ({ listId, users, searchTerm }) => {
    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.StudentsList}>
            <div className={classes.Title}>{texts.studentsToAssociate}</div>
            <div className={classes.List}>
                <ScrollLTR dropStyle={{ height: "100%", padding: "0 15px" }} downDropStyle={{ height: "100%" }}>
                    <DragAndDropStudentList listId={listId} items={users} searchTerm={searchTerm} draggableClass={classes.Student} />
                </ScrollLTR>
            </div>
            <div className={classes.StudentsListNote}>{texts.studentsListNote}</div>
        </div>
    )
}

export default StudentsList;